(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initSlider(section) {
      const viewport = section.querySelector('[data-slider-viewport]');
      if (!viewport) return;

      const track = section.querySelector('[data-slider-track]');
      const slides = section.querySelectorAll('[data-slider-slide]');
      const prevBtn = section.querySelector('[data-slider-prev]');
      const nextBtn = section.querySelector('[data-slider-next]');
      const dots = section.querySelectorAll('[data-slider-dot]');
      const autoplay = section.dataset.autoplay === 'true';
      const autoplaySpeed = parseInt(section.dataset.autoplaySpeed, 10) || 4;

      if (slides.length <= 1) return;

      let currentIndex = 0;
      let autoplayTimer = null;

      function getSlideWidth() {
        return slides[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap) || 0;
      }

      function scrollToIndex(index) {
        const slideWidth = getSlideWidth();
        viewport.scrollTo({ left: index * slideWidth, behavior: 'smooth' });
      }

      function updateControls(index) {
        currentIndex = index;

        if (prevBtn) {
          prevBtn.disabled = index === 0;
        }
        if (nextBtn) {
          nextBtn.disabled = index === slides.length - 1;
        }

        dots.forEach((dot, i) => {
          if (i === index) {
            dot.classList.add('collection-slider__dot--active');
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.classList.remove('collection-slider__dot--active');
            dot.setAttribute('aria-current', 'false');
          }
        });
      }

      function onScroll() {
        const slideWidth = getSlideWidth();
        const newIndex = Math.round(viewport.scrollLeft / slideWidth);
        if (newIndex !== currentIndex && newIndex >= 0 && newIndex < slides.length) {
          updateControls(newIndex);
        }
      }

      function next() {
        if (currentIndex < slides.length - 1) {
          scrollToIndex(currentIndex + 1);
        } else {
          scrollToIndex(0);
        }
      }

      function prev() {
        if (currentIndex > 0) {
          scrollToIndex(currentIndex - 1);
        }
      }

      function startAutoplay() {
        if (!autoplay) return;
        stopAutoplay();
        autoplayTimer = setInterval(next, autoplaySpeed * 1000);
      }

      function stopAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', () => { stopAutoplay(); prev(); });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', () => { stopAutoplay(); next(); });
      }

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          stopAutoplay();
          const index = parseInt(dot.dataset.index, 10);
          scrollToIndex(index);
        });
      });

      viewport.addEventListener('scroll', onScroll, { passive: true });

      section.addEventListener('mouseenter', stopAutoplay);
      section.addEventListener('mouseleave', startAutoplay);
      section.addEventListener('focusin', stopAutoplay);
      section.addEventListener('focusout', startAutoplay);

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!reducedMotion.matches) {
        startAutoplay();
      }

      // Handle theme editor section reloads
      document.addEventListener('shopify:section:load', (event) => {
        if (event.detail.sectionId === section.dataset.sectionId) {
          initSlider(event.target);
        }
      });
    }

    document.querySelectorAll('[data-testid^="collection-slider-"]').forEach(initSlider);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
